import CityPageTemplate from "../city-template/CityPageTemplate";
import { lasCrucesConfig } from "./data";

export default function LasCrucesPage() {
  return <CityPageTemplate config={lasCrucesConfig} />;
}